import { Box } from "@mui/material";
import TkButton from "../../../components/atoms/TkButton";
import { FacilityList } from "../../../type/apiType/IAPI_STA018";
import { TypeTableBody } from "../../../type/componentsType/TkTable";
import { TkGetCode } from "../../../utils/TkGetCode";
import { SexFlug } from "../../../assets/data/Constants";

function funBodyList(
  res: FacilityList[],
  onChange?: any,
  onDelete?: any,
  onDisabled?: any
) {
  const bodyList: TypeTableBody[][] = [];

  res?.forEach((facilities) => {
    facilities.staffList?.forEach((staff) => {
      const data: TypeTableBody[] = [
        {
          children:
            (facilities.facilityNo ?? "") +
            ":" +
            (facilities.facilityName ?? ""),
        },
        {
          children: (staff.staffNo ?? "") + ":" + (staff.staffNameKanji ?? ""),
        },
        {
          children: staff.birthday,
          align: "center",
        },
        {
          children: TkGetCode(SexFlug, staff.sex),
          align: "center",
        },
        {
          children: staff.joinDate,
          align: "center",
        },
        {
          children: (
            <Box className="btns">
              <TkButton
                onClick={() => onChange(staff.staffNo, facilities?.facilityNo)}
                disabled={onDisabled}
              >
                修正
              </TkButton>
              <TkButton
                onClick={() => onDelete(staff.staffNo)}
                disabled={onDisabled}
              >
                削除
              </TkButton>
            </Box>
          ),
        },
      ];

      bodyList.push(data);
    });
  });

  return bodyList;
}

export { funBodyList };
